module.exports = __webpack_public_path__ + "img/footer-1_en.d07958f.jpg";